import { useNavigate } from 'react-router-dom'
import type { Order } from '@/api/types'
import { priorityLabel } from '@/i18n/labels'
import { formatDate, daysUntil } from '@/lib/format'
import { Card, OrderStatusChip, RiskChip, cn } from '@/ui'

export function OrderCard({ order }: { order: Order }) {
  const navigate = useNavigate()
  const days = daysUntil(order.due_at)
  const overdue = days !== null && days < 0 && order.lifecycle_status === 'IN_PRODUCTION'
  return (
    <Card
      className="mb-2 cursor-pointer p-4 active:bg-black/5"
      // Card is a div; attach handler via wrapper
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => navigate(`/orders/${order.id}`)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') navigate(`/orders/${order.id}`)
        }}
      >
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="truncate font-semibold text-tg-text">{order.product_name}</div>
            <div className="truncate text-xs text-tg-hint">
              № {order.order_number} · {order.client_name}
            </div>
          </div>
          <RiskChip level={order.risk_level} />
        </div>
        <div className="mt-2 flex items-center justify-between gap-2">
          <OrderStatusChip status={order.lifecycle_status} />
          <div className={cn('text-xs', overdue ? 'font-medium text-risk-red' : 'text-tg-hint')}>
            {order.priority !== 'NORMAL' && (
              <span className="mr-2">{priorityLabel[order.priority]}</span>
            )}
            до {formatDate(order.due_at)}
          </div>
        </div>
      </div>
    </Card>
  )
}
